module.exports = __webpack_public_path__ + "img/Public.c61ae713.svg";